import { render, staticRenderFns } from "./makerecruitment.vue?vue&type=template&id=b823ddfc"
import script from "./makerecruitment.vue?vue&type=script&lang=js"
export * from "./makerecruitment.vue?vue&type=script&lang=js"
import style0 from "./makerecruitment.vue?vue&type=style&index=0&id=b823ddfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports